import { render, staticRenderFns } from "./AfricanContent.vue?vue&type=template&id=3bd2b23e&scoped=true&"
import script from "./AfricanContent.vue?vue&type=script&lang=js&"
export * from "./AfricanContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2b23e",
  null
  
)

export default component.exports